import http from '../../config/http-common';

//Usado somente se for realmente necessário algo fora do padrão GeneralCRUD.service.js
const path = "agent/inspector"

class service {

    selectList(params) {
        return http.list(path + "/selectList",params);
    }

    getAllInspector() {
        let params = new URLSearchParams()
        params.set("status", "1")
        return http.list(path + "/selectAll",params);
    }


}

export default new service();

